import { PropsWithChildren } from 'react'
import { Box } from '@machobear/design-system'

interface Props extends PropsWithChildren {
  roundCorners?: boolean
  testId: string
}

export const ContentSection = ({ roundCorners = false, children, testId }: Props) => (
  <Box
    borderRadius={roundCorners ? 'standard' : 'none'}
    paddingY="large"
    paddingX={{ mobile: 'gutter', tablet: 'gutter', desktop: 'large' }}
    background="white"
    boxShadow="small"
    display="flex"
    flexDirection="column"
    gap="large"
    data={{ testid: testId }}
  >
    {children}
  </Box>
)
